import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import { LEAVE_SYNDICATE_FAILED } from "src/app/app.constants";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { interval } from "rxjs";
import { SeeYouSoonComponent } from "src/app/components/see-you-soon/see-you-soon.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { bounceIn } from "src/app/animations/custom.animation";
import { ModalController, IonicModule, NavParams } from "@ionic/angular";
import { LeaveSyndicateComponent } from "../leave-syndicate/leave-syndicate.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";
import { Data } from "@angular/router";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { PauseSyndicateComponent } from "../pause-syndicate/pause-syndicate.component";
import { UnpauseSyndicateBottomsheetComponent } from "../unpause-syndicate-bottomsheet/unpause-syndicate-bottomsheet.component";

@Component({
    selector: "app-syndicate-leave",
    templateUrl: "./syndicate-leave.component.html",
    styleUrls: ["./syndicate-leave.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [
        IonicModule,
        MatProgressSpinner,
        MatIcon,
        TranslatePipe,
    ],
})
export class SyndicateLeaveComponent implements OnInit {
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  proceed = true;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  syndicate: Data;
  isPausedChecked = false;
  pause2Credit: string;
  pause2CreditData: Data;
  userId: string;
  isClaimed: boolean;
  constructor(
    private dialog: MatDialogRef<SyndicateLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private syndicateService: SyndicateRepositoryService,
    private snackService: MySnackBarService,
    private analytics: AngularFireAnalytics,
    private matDialog: MatDialog,
    private GTMSegment: GTMSegmentService,
    private modalCtrl: ModalController,
    public translate: TranslateService,
    private authService: AuthService,
    private bottomSheet: MatBottomSheet,
    private modalController: ModalController,
     private navParams: NavParams,
  ) {
    try {
      this.authService.selectedlanguage$?.subscribe(
        (l) => {
          this.selectedLanguage = l;
          translate.use(l ? l : "en");
        },
        (err) => {
          return err;
        }
      );

      this.authService.getConstantsMsg$?.subscribe((msg: any) => {
        this.translatedToastMsg = msg?.static_messages_pwa;
      })
      this.GTMSegment.GTMPopupInitialization("LeaveSegmentConfirm");
    } catch(e) {}
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("SyndicateLeaveComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("syndicate_leave_modal", {
        userId: this.userId,
      });
      })
      .catch((error) => {
        return error;
      });
    
      this.authService.userDetails$.subscribe(
        (user: Data) => {
          this.isClaimed = user?.is_pause_syndicate_gift_assigned ?? false;
        },
        (err) => {
          return err;
        }
      );

    this.syndicate = this.navParams?.data.syndicateData;
    this.isPausedChecked = this.syndicate?.active_status === "paused" ? true : false;

    this.translate.get(['syndicate-leave.pause_2_credit']).subscribe((res: string) => {
      this.pause2CreditData = res['syndicate-leave.pause_2_credit'];
      if (this.pause2CreditData) {
        this.authService
          .getDVFromString(this.pause2CreditData)
          .then((dvString: string) => {
            if (dvString) {
              this.pause2Credit = dvString;
            } else {
              return "";
            }
          })
          .catch((err) => {
            return err;
          });
      }
    });
    
  }

  startSpinner() {
    try {
      this.spinnerAnimation = true;
      this.progressBar = 0;
      this.timer$ = interval(20);
      this.sub = this.timer$?.subscribe(
        (sec) => {
          this.progressBar = 0 + sec;
        },
        (err) => {
          return (err);
        }
      );
    } catch(e) {}
  }

  leaveSyndicate() {
    try {
      this.syndicateService
        .leaveSyndicate(
          this.data?.syndicate?.id
            ? this.data?.syndicate?.id
            : this.data?.syndicate?.encrypted_id
              ? this.data?.syndicate?.encrypted_id
              : this.data?.syndicate?.sId,
          this.data?.syndicate?.cardType,
          this.data?.reason
        )
        ?.subscribe(
          (response) => {
            this.progressBar === 100;
            this.sub?.unsubscribe();
            if (response?.status === "rejected") {
              this.authService.getConstantsMsg(response?.error_code).then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                }
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              }).catch((error) => {
                return error;
              });
              this.dialog.close({ isSuccessLeave: false });
              return;
            }
            if (response && response?.status?.toLowerCase() === "success") {
              const msg = this.matDialog.open(SeeYouSoonComponent, {
                height: "50%",
                data: this.data.syndicate,
              });

              msg?.afterClosed()?.subscribe(
                () => {
                  this.dialog.close({ isSuccessLeave: false });
                },
                (err) => {
                  return (err);
                }
              );
            } else {
              //this.snackService.openSnackBar(LEAVE_SYNDICATE_FAILED, "", "Error", "Error");
              //this.authService.showToast(LEAVE_SYNDICATE_FAILED ? LEAVE_SYNDICATE_FAILED : "Leaving syndicate failed", "Error", "");
              const translatedMsg = {
                message: {
                  line_1: LEAVE_SYNDICATE_FAILED,
                  line_2: "",
                },
                style: {
                  duration: 2000,
                  icon: "tick circle error.svg",
                  type: "Error",
                }
              }
              const defaultMsg = {
                message: {
                  line_1: "Leaving syndicate failed",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
              this.dialog.close({ isSuccessLeave: false });
            }

            setTimeout(() => {
              this.spinnerAnimation = false;
              this.proceed = false;
              setTimeout(() => {
                this.proceed = true;
              }, 2000);
            }, 300);
          },
          (err) => {
            return (err);
          }
        );
    } catch(e) {}
  }
  async confirmLeaveReason() {
    this.dialog.close();
    const leaveSyndicateReason = await this.modalCtrl.create({
      component: LeaveSyndicateComponent,
      cssClass: "modal-fullScreen",
      componentProps: { syndicate: this.data?.syndicate },
    });
    leaveSyndicateReason?.onDidDismiss().then((res) => {
      if (res && res?.data) {
        setTimeout(() => {
          this.modalCtrl.dismiss(res.data);
        }, 100);
      }
    }).catch(err => {
      return err;
    });
    return await leaveSyndicateReason.present();
  }
  closeModal() {
    this.dialog.close({ isSuccessLeave: false });
  }
  GotoSyndicates() {
    this.modalCtrl.dismiss({ data: 'keepPlaying' }).catch(err => { return err });
    this.dialog.close();
  }
    pauseWithCredit(){
      this.dialog.close({ isSuccessLeave: false , syndicate_pause_gift: true });
    }
}
